import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {device} from "../components/Devices";
import {CustomerList} from "../components/BrandList";


function Brands() {

    const [data, setData] = useState([]);

    useEffect(() => {

        setData(CustomerList);
        // console.log(CustomerList)

    }, []);


    return (

        <Section>
            <Header>
                <h1>Some of the Brands I worked for</h1>
            </Header>


            <Main_Brands_Container>

                {data.map((item) => {
                    return (
                        <div
                            className="brand_logo"
                            key={item.id}
                        >
                            <img src={item.img} alt=""/>
                        </div>
                    )
                })}

            </Main_Brands_Container>
        </Section>


    );
}

export default Brands;


const Section = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 100px;
  //border: 1px solid white;

`;


const Header = styled.div`

  height: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  //border: 1px solid black;
  margin-bottom: 20px;

  h1 {
    color: var(--mainTextColor);
    font-weight: lighter;
    text-align: center;
    
  }
;

`;

const Main_Brands_Container = styled.div`

  display: grid;
  grid-template-columns: auto auto;
  flex-wrap: wrap;
  


  width: 320px;
  //border: 1px solid var(--orange);
  gap: 20px;
  margin-top: 20px;
  align-items: center;
  justify-content: center;

  @media ${device.mobileM} {
    width: 375px;
    max-width: 375px;
    grid-template-columns: auto auto auto;
  }

  @media ${device.mobileL} {
    width: 425px;
    max-width: 425px;
    
  }

  @media ${device.tablet} {
    width: 768px;
    max-width: 768px;
    //flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 20px;

  }

  @media ${device.laptop} {
    width: 1420px;
    max-width: 1024px;
    grid-template-columns: auto auto auto auto;
  }

  @media ${device.laptopL} {
    max-width: 1440px;
  }


  .brand_logo {
    width: 100px;
    height: 100px;
    //border: 1px solid var(--orange);
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      color: var(--orange);
      padding: 3px;
    }

    img {
      width: 100px;
      height: 100px;
      top: 0;
      left: 0;
      border-radius: 5px;
    }

  }

`;